import { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { CaseServices } from "../../../services/CaseServices";
import Modal from "@mui/material/Modal";
import "./mapDocumentsModal.scss";
import Select from "react-select";
import { Formik, Form, Field } from "formik";
import { object, string } from "yup";
import { CircularProgress } from "@mui/material";
import CloseIcon from "../../../assets/crossIcon.svg";
import InfoIcon from "../../../assets/infoIcon.svg";
import TooltipIcon from "../../../assets/tooltipTriangle.svg";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import DocumentNameSelect from "../manageProcedure/DocumentNameSelect";
export default function MapDocumentModal({
  documentType,
  caseProcedures,
  caseId,
  getDefaultsDocument,
  handleSave,
  areDocumentsMapped,
}) {
  const [open, setOpen] = useState(false);
  const [required, setRequired] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [width, setWidth] = useState(window.innerWidth);
  const [documentName, setDocumentName] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [latestStage, setLatestStage] = useState(null);
  // const [selectedProc, setSelectedProc] = useState(null);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  console.log(caseProcedures);
  const initialValues =
    caseProcedures?.length === 1
      ? {
          procedure: caseProcedures[0]?.procedure,
          procedureId: caseProcedures[0]?.procedureId,
          documentName: "",
          specialityId: caseProcedures[0]?.specialityId,
          specialityName: caseProcedures[0]?.speciality,
        }
      : {
          procedure: "",
          procedureId: "",
          documentName: "",
          specialityId: "",
          specialityName: "",
        };

  const errorValidation = object({
    procedure: string().required("Required Field"),
    procedureId: string().required("Required Field"),
  });

  const handleMapPermanently = async (values) => {
    if (documentName && documentType) {
      const data = documents
        ?.filter((doc) => doc.isSelected)
        ?.map((doc) => {
          return {
            documentName: doc.docName,
            documentType: documentType.includes("admission")
              ? "ADMISSIONDOCUMENT"
              : documentType.includes("during")
                ? "DURINGTREATMENTDOCUMENT"
                : documentType.includes("discharge")
                  ? "ONDISCHARGEDOCUMENT"
                  : "",
            procedureId: values?.procedureId,
            procedureName: values?.procedure,
            specialityId: values?.specialityId,
            specialityName: values?.specialityName,
            required: true,
          };
        });
      try {
        const response = await CaseServices.addDefaultDocuments(data);
        window.alert(response.data.message);
      } catch (error) {
        handleApiErrorResponses(error);
      }
    } else {
      if (!documentName) window.alert("Document Name Required");
      else if (!documentType) window.alert("Document Type required");
    }
  };

  const handleSubmit = async (values) => {
    if (!documentName?.length) {
      window.alert("Please add document name");
      return;
    }
    let postData = documents?.map((doc) => {
      return {
        documentType: documentType.includes("admission")
          ? "ADMISSIONDOCUMENT"
          : documentType.includes("during")
            ? "DURINGTREATMENTDOCUMENT"
            : documentType.includes("discharge")
              ? "ONDISCHARGEDOCUMENT"
              : "",
        procedure: values.procedure,
        procedureId: documentType.includes("during") ? "" : values.procedureId,
        documentName: doc?.docName,
        required: true,
      };
    });

    if (documentType.includes("during")) {
      postData = [
        ...postData,
        ...postData.map((doc) => ({
          ...doc,
          enhancementId: latestStage?.documents[0]?.enhancementId ?? null,
          documentType: latestStage?.documents[0]?.documentType ?? null,
        })),
      ];
    }
    try {
      setIsSubmitting(true);
      await CaseServices.updateMappedDocuments(postData, caseId);
      getDefaultsDocument();
      await handleMapPermanently(values);
      window.alert("Documents updated successfully");
      handleClose();
    } catch (error) {
      handleApiErrorResponses(error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const getLatestCaseStage = async () => {
    try {
      const response = await CaseServices.getLatestCaseStage(caseId);
      console.log("response: ", response.data);
      if (response?.data?.currnetSubMasterStage[0]) {
        setLatestStage(response?.data);
      }
    } catch (error) {
      handleApiErrorResponses(error);
    }
  };
  // handle window resizing
  useEffect(() => {
    const updateDimensions = () => setWidth(window.innerWidth);
    window.addEventListener("resize", updateDimensions);
    documentType.includes("during") && getLatestCaseStage();
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  useEffect(() => {
    const modifiedData = documentName.map((item) => {
      return {
        isSelected: false,
        docName: item,
      };
    });

    setDocuments(modifiedData);
  }, [documentName]);

  return (
    <div className="map-modal-container">
      <button
        className="outline-btn"
        onClick={() => {
          if (!areDocumentsMapped) handleSave(true);
          handleOpen();
        }}
      >
        <AddOutlinedIcon sx={{ height: "16px" }} />
        {documentType.toUpperCase()}
      </button>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="map-document-modal"
        className="custom-modal"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "90%",
            minHeight: "60vh",
            maxHeight: "90vh", // 🔹 limit modal height
            bgcolor: "background.paper",
            borderRadius: "16px",
            boxShadow: 24,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden", // prevent double scroll
          }}
        >
          {/* --- Modal Header --- */}
          <div
            style={{
              fontFamily: "Inter, sans-serif",
              position: "relative",
              fontSize: "24px",
              fontWeight: 600,
              color: "#191919",
              textAlign: "center",
              padding: "20px 16px",
              borderBottom: "1px solid #E4E4E4",
              flexShrink: 0, // 🔹 Prevent shrinking header
              textTransform: "capitalize",
            }}
          >
            Required{" "}
            {documentType.includes("admission")
              ? "Admission "
              : documentType.includes("during")
                ? "Enhancement "
                : documentType.includes("discharge")
                  ? "Discharge "
                  : ""}
            Document
            <div
              className="absolute top-2 right-4 cursor-pointer"
              onClick={handleClose}
            >
              <img src={CloseIcon} alt="close-icon" />
            </div>
          </div>

          {/* --- Scrollable Form Area --- */}
          <div
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "24px",
            }}
          >
            <Formik
              initialValues={initialValues}
              validationSchema={errorValidation}
              onSubmit={handleSubmit}
            >
              {({ errors, touched, setFieldValue, values }) => (
                <Form>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "16px",
                      justifyContent: "space-between",
                    }}
                  >
                    {/* --- Procedure --- */}
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#191919",
                        gap: "4px",
                        // width: "380px",
                        width: width > 640 ? "380px" : "180px",
                      }}
                    >
                      Procedure
                      <Select
                        name="procedure"
                        options={caseProcedures}
                        getOptionLabel={(opt) => opt.procedure}
                        getOptionValue={(opt) => opt.procedureId}
                        onChange={(item) => {
                          setFieldValue("procedure", item.procedure);
                          setFieldValue("procedureId", item.procedureId);
                          setFieldValue("specialityId", item.specialityId);
                          setFieldValue("specialityName", item.specialityName);
                        }}
                        value={caseProcedures?.filter(
                          (item) => item.procedureId === values.procedureId,
                        )}
                      />
                      {touched.procedure && errors.procedure && (
                        <div className="field-error">{errors.procedure}</div>
                      )}
                    </label>

                    {/* --- Procedure ID --- */}
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#191919",
                        gap: "4px",

                        width: "180px",
                      }}
                    >
                      Procedure ID
                      <Field
                        type="text"
                        name="procedureId"
                        style={{
                          border: "1px solid #E4E4E4",
                          borderRadius: "8px",
                          paddingLeft: "12px",
                          height: "40px",
                          fontFamily: "inherit",
                          color: "#797979",
                          fontSize: "14px",
                          fontWeight: "400",
                        }}
                        disabled
                      />
                      {touched.procedureId && errors.procedureId && (
                        <div className="field-error">{errors.procedureId}</div>
                      )}
                    </label>

                    {/* --- Document Name --- */}
                    <label
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#191919",
                        gap: "4px",
                        width: width > 640 ? "380px" : "100%",
                      }}
                    >
                      Document Name
                      <DocumentNameSelect
                        onChange={setDocumentName}
                        value={documentName}
                        isMulti={true}
                      />
                    </label>
                  </div>
                  {documents?.length > 0 && (
                    <div className=" flex gap-2 items-center font-semibold text-[18px] text-[#017C57] mb-2 mt-3">
                      <div>Map Permanent *</div>

                      <div className="group relative">
                        <img src={InfoIcon} alt="info-icon" />
                        <div className="hidden group-hover:block absolute text-xs -left-[110px] top-[105%]  z-20">
                          <div className="flex justify-center">
                            <img src={TooltipIcon} alt="tooltip-icon" />
                          </div>
                          <div className="text-[12px] text-center  text-white text-nowrap bg-[#017C57] py-2 px-1 rounded-[8px]">
                            Select documents to map permanently.
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <div>
                    {documents?.length > 0 &&
                      documents?.map((doc, idx) => {
                        return (
                          <div key={idx} className="flex gap-2 items-start">
                            <input
                              type="checkbox"
                              checked={doc?.isSelected}
                              onChange={() => {
                                documents[idx].isSelected =
                                  !documents[idx].isSelected;

                                setDocuments([...documents]);
                              }}
                            />
                            <div>{doc.docName}</div>
                          </div>
                        );
                      })}
                  </div>

                  {/* --- Buttons --- */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "32px",
                      marginTop: "48px",
                      paddingBottom: "16px",
                    }}
                  >
                    {isSubmitting ? (
                      <CircularProgress />
                    ) : (
                      <button
                        type="submit"
                        className="outline-btn"
                        style={{
                          height: "34px",
                          width: "160px",
                          borderRadius: "32px",
                          fontFamily: "Inter, sans-serif",
                          fontWeight: "600",
                          fontSize: "12px",
                          backgroundColor: "white",
                          color: "#017C57",
                          border: "1px solid #017C57",
                        }}
                      >
                        SAVE
                      </button>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
